import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { Heading } from 'scouting-ui/lib';

import styles from './CardSection.less';

const CardSection = ({ title, children, className = '', ...rest }) => {
  const classNames = cn(styles.cardSectionContainer, className);
  return (
    <div className={classNames} {...rest}>
      <div className={styles.cardSectionTitle}>
        <Heading font="display-h5">{title}</Heading>
      </div>
      <div>{children}</div>
    </div>
  );
};

CardSection.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
};

export default CardSection;
